// tour operator Inventory
export const ALL_TOURS_LIST_START = "ALL_TOURS_LIST_START";
export const ALL_TOURS_LIST_SUCCESS = "ALL_TOURS_LIST_SUCCESS";
export const ALL_TOURS_LIST_ERROR = "ALL_TOURS_LIST_ERROR";

export const GET_TOUR_LEAD_LIST_START = "GET_TOUR_LEAD_LIST_START";
export const GET_TOUR_LEAD_LIST_SUCCESS = "GET_TOUR_LEAD_LIST_SUCCESS";
export const GET_TOUR_LEAD_LIST_ERROR = "GET_TOUR_LEAD_LIST_ERROR";

export const GET_TOUR_DETAILS_START = "GET_TOUR_DETAILS_START";
export const GET_TOUR_DETAILS_SUCCESS = "GET_TOUR_DETAILS_SUCCESS";
export const GET_TOUR_DETAILS_ERROR = "GET_TOUR_DETAILS_ERROR";

export const ADD_UPDATE_TOURS_START = "ADD_UPDATE_TOURS_START";
export const ADD_UPDATE_TOURS_SUCCESS = "ADD_UPDATE_TOURS_SUCCESS";
export const ADD_UPDATE_TOURS_ERROR = "ADD_UPDATE_TOURS_ERROR";

export const ADD_TOURS_ASSETS_START = "ADD_TOURS_ASSETS_START";
export const ADD_TOURS_ASSETS_SUCCESS = "ADD_TOURS_ASSETS_SUCCESS";
export const ADD_TOURS_ASSETS_ERROR = "ADD_TOURS_ASSETS_ERROR";

export const TOUR_SUBMIT_FOR_APPROVAL_START = "TOUR_SUBMIT_FOR_APPROVAL_START";
export const TOUR_SUBMIT_FOR_APPROVAL_SUCCESS =
  "TOUR_SUBMIT_FOR_APPROVAL_SUCCESS";
export const TOUR_SUBMIT_FOR_APPROVAL_ERROR = "TOUR_SUBMIT_FOR_APPROVAL_ERROR";

export const TOUR_PENDING_FOR_APPROVAL_START =
  "TOUR_PENDING_FOR_APPROVAL_START";
export const TOUR_PENDING_FOR_APPROVAL_SUCCESS =
  "TOUR_PENDING_FOR_APPROVAL_SUCCESS";
export const TOUR_PENDING_FOR_APPROVAL_ERROR =
  "TOUR_PENDING_FOR_APPROVAL_ERROR";

export const TOUR_AWAITING_TRIPS_START = "TOUR_AWAITING_TRIPS_START";
export const TOUR_AWAITING_TRIPS_SUCCESS = "TOUR_AWAITING_TRIPS_SUCCESS";
export const TOUR_AWAITING_TRIPS_ERROR = "TOUR_AWAITING_TRIPS_ERROR";

export const COPY_TRIP_START = "COPY_TRIP_START";
export const COPY_TRIP_SUCCESS = "COPY_TRIP_SUCCESS";
export const COPY_TRIP_ERROR = "COPY_TRIP_ERROR";

export const REJECT_TRIP_REQUEST = "REJECT_TRIP_REQUEST";
export const REJECT_TRIP_SUCCESS = "REJECT_TRIP_SUCCESS";
export const REJECT_TRIP_FAILURE = "REJECT_TRIP_FAILURE";
